import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fac8ca64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fac8ca64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac8ca64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/lasur-lab/lasur-lab-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fac8ca64')) {
      api.createRecord('fac8ca64', component.options)
    } else {
      api.reload('fac8ca64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fac8ca64&scoped=true", function () {
      api.rerender('fac8ca64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/TagsView/index.vue"
export default component.exports